import { Epic } from 'redux-observable';
import { EMPTY, Observable, of } from 'rxjs';

import { Action } from '../../../actions';
import { requestAuthorizationData } from '../../../actions/common';
import {
    FETCH_FREELANCERS_LIST_DATA,
    FetchFreelancersListDataAction,
    setFreelancerCooperationStatus,
    setFreelancersListPageStatus,
    updateFreelancersListData,
    updateSingleFreelancerData
} from '../../../actions/freelancers/freelancers-list';
import { fetchHeaderInfo } from '../../../actions/header';
import { mapFreelacersListPrivateItem, mapFreelancersListItem } from '../../../mappers/freelancers';
import { EpicDeps } from '../../../service/StoreFactory';
import { DnaEpicAction } from '../../../typings/epic';
import { FreelancerPageStates, FreelancersListItem } from '../../../typings/freelancers';
import { FreelancersListUpdateQuery } from '../../../typings/graphql-grid';
import {
    FreelancersListItemFragment,
    FreelancersListQuery as FreelancerListQueryPublic,
    FreelancersListQuery_operator
} from '../../../typings/graphql-public-grid';
import { State } from '../../../typings/state';

export const fetchFreelancersListDataEpic: Epic<Action, Action, State, EpicDeps> = (action$, store$, deps) => {
    return action$.ofType(FETCH_FREELANCERS_LIST_DATA).mergeMap(
        (action: FetchFreelancersListDataAction): Observable<Action> => {
            return Observable.fromPromise(deps.incognitoDataProvider.fetchFreelancersListData())
                .map((response: FreelancerListQueryPublic) => [
                    response.freelancersList
                        .filter(item => item)
                        .map((item: FreelancersListItemFragment) => mapFreelancersListItem(item)),
                    response.operator
                ])
                .map(([freelancersListItems, operator]: [FreelancersListItem[], FreelancersListQuery_operator]) => {
                    const { freelancerLogins } = action;
                    let payload = freelancersListItems;

                    if (freelancerLogins) {
                        payload = freelancersListItems.filter(item => freelancerLogins.indexOf(item.login) !== -1);
                    }
                    return [payload, operator];
                })
                .mergeMap(
                    ([freelancersListItems, operator]: [FreelancersListItem[], FreelancersListQuery_operator]) => {
                        let privateFreelanersListAction$: DnaEpicAction = EMPTY;

                        const publicUpdateAction$ = Observable.of(
                            updateFreelancersListData(freelancersListItems, action.sortParams)
                        );

                        // клиент есть в Директе
                        if (operator && operator.clientId) {
                            privateFreelanersListAction$ = Observable.fromPromise(
                                deps.freelancerDataProvider.fetchFreelancersListUpdateData(action.login)
                            ).mergeMap(
                                (response: FreelancersListUpdateQuery): DnaEpicAction => {
                                    const [freelancerProject] = response.client.freelancerProjects;
                                    const freelancerId = freelancerProject && String(freelancerProject.freelancerId);

                                    const [item] = response.freelancersList.filter(elem => elem);

                                    // пользователь клиент этого фрилансера
                                    if (freelancerId) {
                                        return of(setFreelancerCooperationStatus(freelancerId));

                                        // пользователь сам является этим фрилансером
                                    } else if (item && item.privateData && item.privateData.newestCard) {
                                        return of(
                                            updateSingleFreelancerData(
                                                String(item.privateData.freelancerId),
                                                mapFreelacersListPrivateItem(item.privateData.newestCard)
                                            )
                                        );
                                    }

                                    // пользователь не фрилансер и не клиент этого фрилансера
                                    return EMPTY;
                                }
                            );

                            return Observable.concat(
                                Observable.of(requestAuthorizationData()),
                                publicUpdateAction$,
                                privateFreelanersListAction$
                            );
                        }

                        return Observable.concat(Observable.of(fetchHeaderInfo()), publicUpdateAction$);
                    }
                )
                .catch(() => {
                    return Observable.of(setFreelancersListPageStatus(FreelancerPageStates.ERROR));
                });
        }
    );
};
